export const isLeftButtonPressed = e =>
  // eslint-disable-next-line no-bitwise
  Boolean(e.buttons & 0b001);

export const isRightButtonPressed = e =>
  // eslint-disable-next-line no-bitwise
  Boolean(e.buttons & 0b010);

export const isMiddleButtonPressed = e =>
  // eslint-disable-next-line no-bitwise
  Boolean(e.buttons & 0b100);

export const isMouseZooming = (e): boolean => {
  if (e.wheelDeltaY) {
    if (Math.abs(e.wheelDeltaY - e.deltaY * -3) <= 1) {
      return false;
    }
  } else if (e.deltaMode === 0) {
    return false;
  }

  return true;
};

export const isCtrlPressed = (e): boolean => e.ctrlKey || e.metaKey;
